import React, { useEffect, useRef, useState } from "react";
import { useCalcContext } from "../Contexts/CalcContext";
import { useAuthContext } from "../Contexts/AuthContext";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import Logo from "../assets/Logo.svg";
import venezuelaimg from "../assets/VENEZUELA.jpg"
import europeimg from "../assets/Europe.jpg"
import BankSlider from "./BankSlider";
import { LuArrowUpDown } from "react-icons/lu";


const getDynamicFee = (amountStr) => {
  const num = parseFloat(
    (amountStr || "0").replaceAll(".", "").replaceAll(",", ".")
  ) || 0;
  if (num > 100) return parseFloat((num * 0.05).toFixed(2));
  return 5;
};

const SERVICE_PAUSED = true;

const Calculator = ({ btn }) => {
  const { user, userdata } = useAuthContext();
  const [status, setStatus] = useState("");
  const [id, setId] = useState("");
  const navigate = useNavigate();
  const { setCalc } = useCalcContext();
  const country = useRef();
  const [filterData, setFilter] = useState([]);
  const [isEuroToVes, setIsEuroToVes] = useState([]);
  const countryInp = useRef();
  const [first, setFirst] = useState(true);
  const curr2 = useRef();
  const totalFees = useRef();
  const exchangerate = useRef();
  const flag = useRef();
  const gets = useRef();
  const amountInp = useRef();
  const total = useRef();
  const [data, setData] = useState([]);
  const [notifyEmail, setNotifyEmail] = useState(userdata?.email || "");
  const [notifySent, setNotifySent] = useState(false);
  const [notifyLoading, setNotifyLoading] = useState(false);

  const handleNotifyMe = async () => {
    if (!notifyEmail || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(notifyEmail)) {
      toast.error("Ingresa un email válido", { position: "top-center", theme: "dark" });
      return;
    }
    try {
      setNotifyLoading(true);
      await axios.post(process.env.REACT_APP_BASE_URL + "/api/orders/notify", { email: notifyEmail });
      setNotifySent(true);
      toast.success("¡Te avisaremos en cuanto estemos disponibles!", { position: "top-center", theme: "dark" });
    } catch (err) {
      toast.error("Hubo un error, intenta de nuevo", { position: "top-center", theme: "dark" });
    } finally {
      setNotifyLoading(false);
    }
  };

  useEffect(() => {
    if (SERVICE_PAUSED) return;
    const Fetch = async () => {
      const { data } = await axios.get(
        process.env.REACT_APP_BASE_URL + "/api/rates/getrates"
      );

      curr2.current.innerHTML = data.data[0].NOM;
      countryInp.current.value = data.data[0].COUNTRY;
      exchangerate.current.innerHTML = data.data[0].EXCHRATE;
      totalFees.current.innerHTML = "0,00€";
      flag.current.style.display = "flex";
      flag.current.src = data.data[0].FLAG;

      setData(data?.data?.sort((a, b) => a.COUNTRY.localeCompare(b.COUNTRY)));
    };
    Fetch();
  }, []);

  function showList(e) {
    var filtered = data.filter((elem) => {
      return elem.COUNTRY.toLowerCase().startsWith(e.target.value.toLowerCase());
    });
    setFilter(filtered);
  }

  let countryData = [];

  const setCountry = (country, nom) => {
    curr2.current.innerHTML = nom;
    countryInp.current.value = country;

    countryData = data.filter((elem) => {
      return elem.NOM === nom && elem.COUNTRY === country;
    });

    // Reset fee to default 5€ when country changes (amount will be cleared)
    totalFees.current.innerHTML = "0,00€";
    exchangerate.current.innerHTML = countryData[0].EXCHRATE + " " + nom;
    flag.current.style.display = "flex";
    flag.current.src = countryData[0].FLAG;
    Calculate();
  };

  function Calculate() {
    if (data.length === 0) return;

    const venezuelaData = data.find((elem) => elem.COUNTRY === "Venezuela");
    const europeData = data.find((elem) => elem.COUNTRY === "Europe");

    if (!venezuelaData || !europeData) return;

    const eurToVesRate = parseFloat(venezuelaData.EXCHRATE.replace(",", "."));
    const vesToEurRate = 1 / eurToVesRate;

    const amount = parseFloat(
      amountInp.current.value.replaceAll(".", "").replace(",", ".")
    ) || 0;

    // Normal transfer fee is now 0€ — full amount converts, full amount is paid
    totalFees.current.innerHTML = "0,00€";

    let getValue = 0;
    if (isEuroToVes) {
      getValue = amount * eurToVesRate;
    } else {
      getValue = amount * vesToEurRate;
    }

    exchangerate.current.innerHTML = isEuroToVes
      ? `${eurToVesRate.toLocaleString("es-ES")} VES`
      : `${vesToEurRate.toFixed(6)} EUR`;

    gets.current.value = getValue.toLocaleString("es-ES", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

    // Total to pay = exactly what the user typed (no fee, no extra added)
    total.current.value = amount.toLocaleString("es-ES", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }

  useEffect(() => {
    if (SERVICE_PAUSED) return;
    if (isEuroToVes) {
      curr2.current.innerHTML = "VES";
    } else {
      curr2.current.innerHTML = "EUR";
    }
  }, [isEuroToVes]);

  const CheckStatus = async () => {
    try {
      const { data } = await axios.put(
        process.env.REACT_APP_BASE_URL + "/api/orders/checkstatus",
        { orderId: id.replace("TV", "").replace("tv", "") }
      );
      setStatus(data?.status);
    } catch (err) {
      toast.error("Número de Orden no existe", { position: "top-center", theme: "dark" });
      console.log(err);
    }
  };

  const CheckColor = (elem) => {
    if (elem.toUpperCase() === "PENDIENTE" || elem.toUpperCase() === "ANULADA") return "red";
    if (elem.toUpperCase() === "COMPLETADA") return "green";
    return "blue";
  };

  const Continue = () => {
    if (
      countryInp.current.value.length > 0 &&
      totalFees.current.innerHTML &&
      total.current.value.length > 0
    ) {
      user ? navigate("/prealertar") : navigate("/registro");
    } else {
      toast.error("Por favor complete el siguiente formulario", { position: "top-center", theme: "dark" });
    }
  };

  const format = (e) => {
    var num = e.target.value
      .replaceAll(".", "")
      .replaceAll(" ", "")
      .replaceAll(",00", "")
      .replaceAll(",0", "");

    var num2 = num.split(/(?=(?:\d{3})+$)/).join(".");
    e.target.value = num2.replaceAll(",00", "").replaceAll(",0", "").replaceAll(",", "") + ",00";

    const cursorPosition = e.target.selectionStart;
    const commaPosition = e.target.value.indexOf(',');

    if (cursorPosition <= commaPosition) {
      e.target.setSelectionRange(cursorPosition, cursorPosition);
    } else {
      e.target.setSelectionRange(commaPosition, commaPosition);
    }
  };

  const toggleDirection = () => {
    setIsEuroToVes((prev) => !prev);
    gets.current.value = "";
    total.current.value = "";
    amountInp.current.value = "";
    // Reset fee to 5€ when direction is toggled and amount is cleared
    totalFees.current.innerHTML = "0,00€";

    const venezuelaData = data.find((elem) => elem.COUNTRY === "Venezuela");
    const europeData = data.find((elem) => elem.COUNTRY === "Europe");

    if (!venezuelaData || !europeData) return;

    if (!isEuroToVes) {
      exchangerate.current.innerHTML = venezuelaData.EXCHRATE + " VES";
    } else {
      exchangerate.current.innerHTML = "1.00 EUR";
    }
  };

  return (
    <div className="calculator wv-calc2">
      <style>{`
        div.wv-calc2 {
          /* --- brand accent (Walletven red). Change here if the exact hex differs --- */
          --accent: #F6394F;
          --accent-strong: #e22440;
          --accent-tint: #fff1f3;
          --ink: #101828;
          --muted: #667085;
          --label: #475467;
          --field: #f5f6f8;
          --field-border: #ececf0;
          --card-border: #ececec;

          background: #ffffff;
          border: 1px solid var(--card-border);
          border-radius: 20px;
          padding: 24px;
          box-shadow: 0 10px 34px rgba(16, 24, 40, 0.05);
          color: var(--ink);
          box-sizing: border-box;
        }
        .wv-calc2 * { box-sizing: border-box; }

        .wv-calc2 .wv-logo { display: block; margin: 0 auto 18px; }

        /* segmented tabs */
        .wv-calc2 .wv-tabs {
          display: flex;
          background: var(--field);
          border-radius: 12px;
          padding: 4px;
          margin-bottom: 18px;
        }
        .wv-calc2 .wv-tab {
          flex: 1;
          border: none;
          background: none;
          padding: 10px;
          border-radius: 9px;
          font-weight: 600;
          font-size: 0.95rem;
          color: var(--muted);
          cursor: pointer;
          transition: background 0.15s ease, color 0.15s ease, box-shadow 0.15s ease;
        }
        .wv-calc2 .wv-tab.active {
          background: #ffffff;
          color: var(--accent);
          box-shadow: 0 1px 3px rgba(16, 24, 40, 0.12);
        }

        .wv-calc2 .wv-field { margin-top: 16px; }
        .wv-calc2 .wv-field:first-of-type { margin-top: 0; }
        .wv-calc2 .wv-label {
          display: block;
          font-weight: 600;
          font-size: 0.9rem;
          color: var(--label);
          margin-bottom: 8px;
        }

        /* combined input + flag + currency */
        .wv-calc2 .wv-field-box {
          display: flex;
          align-items: center;
          background: var(--field);
          border: 1px solid var(--field-border);
          border-radius: 11px;
          overflow: hidden;
          transition: border-color 0.15s ease, box-shadow 0.15s ease, background 0.15s ease;
        }
        .wv-calc2 .wv-field-box:focus-within {
          background: #ffffff;
          border-color: var(--accent);
          box-shadow: 0 0 0 3px rgba(246, 57, 79, 0.14);
        }
        .wv-calc2 .wv-field-box input {
          flex: 1;
          min-width: 0;
          border: none;
          background: transparent;
          padding: 14px 16px;
          font-size: 1rem;
          color: var(--ink);
          outline: none;
        }
        .wv-calc2 .wv-field-box input:disabled { color: var(--ink); -webkit-text-fill-color: var(--ink); opacity: 1; }
        .wv-calc2 .wv-field-box .wv-flag {
          width: 38px;
          height: 26px;
          object-fit: cover;
          border-radius: 4px;
          margin-right: 6px;
        }
        .wv-calc2 .wv-field-box .wv-curr {
          align-self: stretch;
          display: flex;
          align-items: center;
          padding: 0 14px;
          font-weight: 700;
          font-size: 0.82rem;
          color: var(--muted);
          border-left: 1px solid var(--field-border);
          background: rgba(16, 24, 40, 0.02);
        }

        /* standalone input (email / localizador) */
        .wv-calc2 .wv-input {
          width: 100%;
          background: var(--field);
          border: 1px solid var(--field-border);
          border-radius: 11px;
          padding: 14px 16px;
          font-size: 1rem;
          color: var(--ink);
          outline: none;
          transition: border-color 0.15s ease, box-shadow 0.15s ease, background 0.15s ease;
        }
        .wv-calc2 .wv-input::placeholder { color: #98a2b3; }
        .wv-calc2 .wv-input:focus {
          background: #ffffff;
          border-color: var(--accent);
          box-shadow: 0 0 0 3px rgba(246, 57, 79, 0.14);
        }

        /* summary */
        .wv-calc2 .wv-summary {
          margin-top: 16px;
          background: var(--field);
          border-radius: 12px;
          padding: 12px 16px;
        }
        .wv-calc2 .wv-summary .wv-row {
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-size: 0.9rem;
          color: var(--muted);
        }
        .wv-calc2 .wv-summary .wv-row + .wv-row { margin-top: 8px; }
        .wv-calc2 .wv-summary .wv-row b { color: var(--ink); font-weight: 700; }

        .wv-calc2 .wv-note { margin: 10px 0 0; font-size: 0.78rem; color: #98a2b3; }

        .wv-calc2 .wv-submit {
          width: 100%;
          margin-top: 18px;
          padding: 15px;
          background: var(--accent);
          color: #ffffff;
          font-weight: 700;
          font-size: 1rem;
          border: none;
          border-radius: 11px;
          cursor: pointer;
          transition: background 0.15s ease, transform 0.05s ease;
        }
        .wv-calc2 .wv-submit:hover:not(:disabled) { background: var(--accent-strong); }
        .wv-calc2 .wv-submit:active:not(:disabled) { transform: translateY(1px); }
        .wv-calc2 .wv-submit:disabled { opacity: 0.6; cursor: not-allowed; }

        /* paused state */
        .wv-calc2 .wv-paused { text-align: center; padding: 14px 4px; }
        .wv-calc2 .wv-paused-title { font-size: 1.05rem; font-weight: 700; color: var(--ink); margin: 0 0 8px; }
        .wv-calc2 .wv-paused-text { color: var(--muted); font-size: 0.92rem; line-height: 1.6; margin: 0 0 16px; }
        .wv-calc2 .wv-success { color: #12b76a; font-weight: 600; margin: 0; }

        /* status badge */
        .wv-calc2 .wv-status {
          display: inline-block;
          padding: 8px 22px;
          border-radius: 999px;
          font-weight: 700;
          font-size: 1rem;
          margin-bottom: 4px;
        }
        .wv-calc2 .wv-status.red { background: var(--accent-tint); color: var(--accent); }
        .wv-calc2 .wv-status.green { background: #e7f8f0; color: #12b76a; }
        .wv-calc2 .wv-status.blue { background: #eaf4ff; color: #2f8fe6; }
      `}</style>

      <img
        src={Logo}
        height={window.matchMedia("(max-width: 500px)").matches ? 40 : 50}
        className="wv-logo"
        alt="Transferven"
      />

      <div className="wv-tabs">
        <button
          type="button"
          className={`wv-tab ${first ? "active" : ""}`}
          onClick={() => setFirst(true)}
        >
          Calcular
        </button>
        <button
          type="button"
          className={`wv-tab ${!first ? "active" : ""}`}
          onClick={() => setFirst(false)}
        >
          Localizador
        </button>
      </div>

      {first ? (
        SERVICE_PAUSED ? (
          <div className="wv-paused">
            <h5 className="wv-paused-title">Servicio Temporalmente Pausado</h5>
            <p className="wv-paused-text">
              Los servicios Transferven se están adecuando a las nuevas normativas legales.
              Estaremos disponibles en breve. Disculpen las molestias.
            </p>
            {!notifySent ? (
              <div className="mt-3">
                {!userdata?.email && (
                  <input
                    type="email"
                    className="wv-input"
                    style={{ marginBottom: "12px" }}
                    placeholder="Tu correo electrónico"
                    value={notifyEmail}
                    onChange={(e) => setNotifyEmail(e.target.value)}
                  />
                )}
                <button
                  type="button"
                  className="wv-submit"
                  style={{ marginTop: 0 }}
                  onClick={handleNotifyMe}
                  disabled={notifyLoading}
                >
                  {notifyLoading ? "Enviando..." : "Avísame cuando esté disponible"}
                </button>
              </div>
            ) : (
              <p className="wv-success">✓ Te avisaremos por correo en cuanto reactivemos el servicio.</p>
            )}
          </div>
        ) : (
          <>
            {/* Destino (hidden — refs preserved for the rates API) */}
            <div style={{ display: "none" }}>
              <label>Destino</label>
              <div
                style={{ position: "relative", width: "100%" }}
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <img id="flag" ref={flag} alt={`Latinotransfer `} />
                <input
                  type="text"
                  onInput={(e) => showList(e)}
                  id="countryInp"
                  ref={countryInp}
                  autoComplete="off"
                />
                <div style={{ position: "static" }}>
                  <button type="button"></button>
                  <ul id="country" ref={country}>
                    {filterData.length > 0
                      ? filterData.map((elem) => (
                        <li key={elem.NOM} type="button"
                          onClick={() => setCountry(`${elem.COUNTRY}`, `${elem.NOM}`)}>
                          {elem.COUNTRY}
                        </li>
                      ))
                      : data.map((elem) => (
                        <li type="button" key={elem.COUNTRY}
                          onClick={() => setCountry(`${elem.COUNTRY}`, `${elem.NOM}`)}>
                          {elem.COUNTRY}
                        </li>
                      ))}
                  </ul>
                </div>
              </div>
            </div>

            <div className="wv-field">
              <label className="wv-label">Envía</label>
              <div className="wv-field-box">
                <input
                  type="text"
                  id="amountInp"
                  inputMode="numeric"
                  onInput={(e) => { format(e); Calculate(); }}
                  ref={amountInp}
                />
                <img className="wv-flag" src={isEuroToVes ? europeimg : venezuelaimg} alt="" />
                <div className="wv-curr">{isEuroToVes ? 'EUR' : "VES"}</div>
              </div>
            </div>

            {/* direction toggle (hidden — logic preserved) */}
            <div style={{ display: "none" }}>
              <LuArrowUpDown style={{ cursor: "pointer" }} size={23} onClick={toggleDirection} />
            </div>

            <div className="wv-field">
              <label className="wv-label">Recibe*</label>
              <div className="wv-field-box">
                <input type="text" id="gets" ref={gets} onChange={(e) => format(e)} disabled={true} />
                <img className="wv-flag" src={isEuroToVes ? venezuelaimg : europeimg} alt="" />
                <div className="wv-curr" id="curr2" ref={curr2}></div>
              </div>
            </div>

            <div className="wv-summary">
              <div className="wv-row">
                <span>Comisión</span>
                <b><span id="totalFees" ref={totalFees}></span></b>
              </div>
              <div className="wv-row">
                <span>Tasa</span>
                <b>1 EUR = <span id="exchangerate" ref={exchangerate}></span></b>
              </div>
            </div>

            <div className="wv-field">
              <label className="wv-label">Total a pagar</label>
              <div className="wv-field-box">
                <input type="text" id="total" ref={total} onInput={(e) => format(e)} disabled={true} />
                <div className="wv-curr">{isEuroToVes ? 'EUR' : "VES"}</div>
              </div>
            </div>

            <p className="wv-note">*Resultado sujeto a tasas y tipos de cambio variables.</p>

            {btn && (
              <button onClick={Continue} className="wv-submit">Continuar</button>
            )}
          </>
        )
      ) : (
        <div>
          {status?.length === 0 ? (
            <div className="wv-field">
              <label className="wv-label">Número de Órden</label>
              <input className="wv-input" onChange={(e) => setId(e.target.value)} required />
              <button type="button" onClick={CheckStatus} className="wv-submit">BUSCAR</button>
            </div>
          ) : (
            <div style={{ textAlign: "center" }}>
              <span className={`wv-status ${CheckColor(status)}`}>
                {status.toUpperCase()}
              </span>
              <button onClick={() => setStatus("")} className="wv-submit">Volver</button>
            </div>
          )}
        </div>
      )}

      {!SERVICE_PAUSED && <BankSlider />}
    </div>
  );
};

export default (Calculator);